export default {
  data() {
    return {
      packageDialogVisible: false,
      packageDetails: {},
      packageAvailability: {},
      currentPkgNo: '',
      currentPackageDetail: null,
      currentPackageUnavailableMessage: '',
      currentPackageLoading: false,
      selectedSpecs: {},
      availableSpecs: [],
      originalSkus: [],
      matchedSKUs: [],
      lastSpecMulti: false,
      specQuantities: {},
      selectedOptions: {
        pkg_no: '',
        selectedDate: '',
        endDate: '',
        selectedDates: [],
        selectedTimeSlot: '',
        selectedSKUs: [],
        totalDays: 1,
      },
    };
  },
  computed: {
    currentPackage() {
      return this.packages.find((pkg) => String(pkg.pkg_no) === String(this.currentPkgNo)) || {};
    },
    currentItem() {
      if (!this.currentPackageDetail || !this.currentPackageDetail.item || !this.currentPackageDetail.item.length) {
        return null;
      }
      return this.currentPackageDetail.item[0];
    },
    datePickerType() {
      const type = this.currentPackageDetail && this.currentPackageDetail.go_date_setting
        ? this.currentPackageDetail.go_date_setting.type
        : '01';
      if (type === '02' || type === '05') return 'daterange';
      return 'date';
    },
    showDatePicker() {
      const type = this.currentPackageDetail && this.currentPackageDetail.go_date_setting
        ? this.currentPackageDetail.go_date_setting.type
        : '01';
      return type !== '03' && type !== '04';
    },
    datePickerValue() {
      if (this.datePickerType === 'daterange') {
        if (this.selectedOptions.selectedDate && this.selectedOptions.endDate) {
          return [this.selectedOptions.selectedDate, this.selectedOptions.endDate];
        }
        return [];
      }
      return this.selectedOptions.selectedDate || '';
    },
    datePickerOptions() {
      return {
        disabledDate: this.isDateDisabled,
      };
    },
    timeSlots() {
      const date = this.selectedOptions.selectedDate;
      if (!date) return [];
      const slots = [];
      this.originalSkus.forEach((sku) => {
        const dayInfo = sku.calendar_detail && sku.calendar_detail[date];
        const priceInfo = dayInfo && (dayInfo.b2c_price || dayInfo.b2b_price);
        if (!priceInfo) return;
        if (typeof priceInfo === 'object' && !Array.isArray(priceInfo)) {
          Object.keys(priceInfo).forEach((slot) => {
            if (slots.indexOf(slot) === -1) slots.push(slot);
          });
        } else if (slots.indexOf('fullday') === -1) {
          slots.push('fullday');
        }
      });
      return slots;
    },
    hasTimeSlots() {
      return !!(this.currentItem && this.currentItem.has_event) || this.timeSlots.length > 1;
    },
    totalQuantity() {
      return this.selectedOptions.selectedSKUs.reduce((total, sku) => total + (Number(sku.quantity) || 0), 0);
    },
    totalPrice() {
      return this.selectedOptions.selectedSKUs.reduce((total, sku) => {
        return total + (this.getSkuFinalPrice(sku) * (Number(sku.quantity) || 0) * this.selectedOptions.totalDays);
      }, 0);
    },
    totalPriceB2C() {
      return this.selectedOptions.selectedSKUs.reduce((total, sku) => {
        return total + (this.getSkuFinalPriceB2C(sku) * (Number(sku.quantity) || 0) * this.selectedOptions.totalDays);
      }, 0);
    },
    displayDateText() {
      if (!this.selectedOptions.selectedDate) return '';
      if (this.selectedOptions.endDate) {
        return this.selectedOptions.selectedDate + ' 至 ' + this.selectedOptions.endDate;
      }
      return this.selectedOptions.selectedDate;
    },
  },
  methods: {
    async loadPackageDetail(pkg, force) {
      if (!pkg || !pkg.pkg_no) return null;
      if (!force && this.packageDetails[pkg.pkg_no]) return this.packageDetails[pkg.pkg_no];
      const res = await this.get('/kkday_product/package', {
        prod_no: this.prodNo,
        pkg_no: pkg.pkg_no,
      }, 'get', false);
      const detail = res.package_data || res;
      if (!this.isValidPackageDetail(detail)) {
        const error = new Error(this.getPackageDetailErrorMessage(detail));
        error.code = 'PACKAGE_UNAVAILABLE';
        throw error;
      }
      this.$set(this.packageDetails, pkg.pkg_no, detail);
      return detail;
    },
    async prefetchPackageAvailability() {
      if (!this.packages || !this.packages.length) return;
      await Promise.all(this.packages.map(async (pkg) => {
        const pkgNo = String(pkg.pkg_no);
        if (this.packageAvailability[pkgNo]) return;
        this.$set(this.packageAvailability, pkgNo, {
          loading: true,
          available: false,
          message: '',
        });
        try {
          await this.loadPackageDetail(pkg);
          this.$set(this.packageAvailability, pkgNo, {
            loading: false,
            available: true,
            message: '',
          });
        } catch (error) {
          this.$set(this.packageAvailability, pkgNo, {
            loading: false,
            available: false,
            message: '当前套餐不可购买',
          });
        }
      }));
    },
    async openPackageDialog() {
      this.packageDialogVisible = true;
      if (!this.packages.length) return;
      await this.prefetchPackageAvailability();
      const preferredPkg = this.currentPkgNo ? this.currentPackage : null;
      const pkg = preferredPkg && preferredPkg.pkg_no
        ? preferredPkg
        : this.getFirstAvailablePackage() || this.packages[0];
      await this.selectPackage(pkg);
    },
    getFirstAvailablePackage() {
      return this.packages.find((pkg) => this.isPackageAvailable(pkg));
    },
    isPackageAvailable(pkg) {
      if (!pkg || !pkg.pkg_no) return false;
      const status = this.packageAvailability[String(pkg.pkg_no)];
      if (!status) return true;
      if (status.loading) return true;
      return !!status.available;
    },
    getPackageAvailabilityMessage(pkg) {
      if (!pkg || !pkg.pkg_no) return '';
      const status = this.packageAvailability[String(pkg.pkg_no)];
      if (!status) return '';
      return status.message || '';
    },
    async selectPackage(pkg) {
      if (!pkg || !pkg.pkg_no) return;
      this.currentPkgNo = String(pkg.pkg_no);
      this.currentPackageLoading = true;
      this.resetPurchaseState();
      this.selectedOptions.pkg_no = pkg.pkg_no;
      try {
        const detail = await this.loadPackageDetail(pkg);
        this.$set(this.packageAvailability, String(pkg.pkg_no), {
          loading: false,
          available: true,
          message: '',
        });
        this.currentPackageUnavailableMessage = '';
        this.currentPackageDetail = detail;
        this.initSKUList(detail);
        this.applyDefaultDate(detail);
      } catch (error) {
        this.$set(this.packageAvailability, String(pkg.pkg_no), {
          loading: false,
          available: false,
          message: '当前套餐不可购买',
        });
        this.currentPackageDetail = null;
        this.currentPackageUnavailableMessage = '当前套餐不可购买';
      } finally {
        this.currentPackageLoading = false;
      }
    },
    isValidPackageDetail(detail) {
      if (!detail) return false;
      if (detail.result_msg && /pkg_no is not correct|MISSING_FIELD/i.test(detail.result_msg)) return false;
      if (detail.item && Array.isArray(detail.item)) return true;
      if (detail.go_date_setting || detail.description_module || detail.pkg_name) return true;
      return false;
    },
    getPackageDetailErrorMessage(detail) {
      if (detail && detail.result_msg) {
        if (/pkg_no is not correct/i.test(detail.result_msg)) return '当前套餐不可购买';
        return detail.result_msg;
      }
      return '当前套餐不可购买';
    },
    resetPurchaseState() {
      this.currentPackageDetail = null;
      this.currentPackageUnavailableMessage = '';
      this.selectedSpecs = {};
      this.availableSpecs = [];
      this.originalSkus = [];
      this.matchedSKUs = [];
      this.lastSpecMulti = false;
      this.specQuantities = {};
      this.selectedOptions.selectedDate = '';
      this.selectedOptions.endDate = '';
      this.selectedOptions.selectedDates = [];
      this.selectedOptions.selectedTimeSlot = '';
      this.selectedOptions.selectedSKUs = [];
      this.selectedOptions.totalDays = 1;
    },
    initSKUList(detail) {
      const item = detail && detail.item && detail.item.length ? detail.item[0] : null;
      if (!item) return;
      this.availableSpecs = item.specs || [];
      this.lastSpecMulti = !!item.last_spec_multi;
      this.originalSkus = (item.skus || []).map((sku) => {
        return {
          ...sku,
          display_name: this.getSpecDisplayNamesFromSku(sku).join(' + '),
          quantity: 0,
        };
      });
      this.autoSelectSpecs();
      this.matchSKUs();
      if (this.availableSpecs.length === 0 && this.originalSkus.length === 1 && !this.lastSpecMulti) {
        this.originalSkus[0].quantity = 1;
        this.matchedSKUs = [this.originalSkus[0]];
        this.updateSelectedSKUs();
      }
    },
    autoSelectSpecs() {
      this.availableSpecs.forEach((spec, index) => {
        if (this.lastSpecMulti && index === this.availableSpecs.length - 1) return;
        if (spec.spec_items && spec.spec_items.length === 1) {
          this.$set(this.selectedSpecs, spec.spec_oid, spec.spec_items[0].spec_item_oid);
        }
      });
    },
    applyDefaultDate(detail) {
      const goSetting = detail && detail.go_date_setting ? detail.go_date_setting.type : '01';
      if (goSetting === '03' || goSetting === '04') {
        const defaultDate = this.getOpenDateDefault(detail);
        this.selectedOptions.selectedDate = defaultDate;
        this.selectedOptions.selectedDates = [defaultDate];
        this.selectedOptions.totalDays = 1;
      }
      if (!this.showDatePicker) {
        this.syncTimeSlotAfterDateChange();
      }
    },
    getOpenDateDefault(detail) {
      const today = new Date();
      today.setDate(today.getDate() + 1);
      const saleStart = detail && detail.sale_s_date ? new Date(detail.sale_s_date) : null;
      const date = saleStart && saleStart > today ? saleStart : today;
      return this.formatDate(date);
    },
    handleDateInput(value) {
      if (!value || (Array.isArray(value) && !value.length)) {
        this.selectedOptions.selectedDate = '';
        this.selectedOptions.endDate = '';
        this.selectedOptions.selectedDates = [];
        this.selectedOptions.totalDays = 1;
        this.selectedOptions.selectedTimeSlot = '';
        this.clearQuantities();
        return;
      }

      if (Array.isArray(value)) {
        this.selectedOptions.selectedDate = value[0];
        this.selectedOptions.endDate = value[1];
        this.selectedOptions.selectedDates = value;
        this.selectedOptions.totalDays = this.calculateDays(value[0], value[1]) + 1;
      } else {
        this.selectedOptions.selectedDate = value;
        this.selectedOptions.endDate = '';
        this.selectedOptions.selectedDates = [value];
        this.selectedOptions.totalDays = 1;
      }

      this.syncTimeSlotAfterDateChange();
      this.clearQuantities();
    },
    syncTimeSlotAfterDateChange() {
      if (!this.timeSlots.length) {
        this.selectedOptions.selectedTimeSlot = '';
        return;
      }
      if (this.timeSlots.indexOf(this.selectedOptions.selectedTimeSlot) === -1) {
        this.selectedOptions.selectedTimeSlot = this.timeSlots.length === 1 ? this.timeSlots[0] : '';
      }
    },
    clearQuantities() {
      this.matchedSKUs = this.matchedSKUs.map((sku) => ({ ...sku, quantity: 0 }));
      this.specQuantities = {};
      this.updateSelectedSKUs();
    },
    isDateDisabled(time) {
      if (!this.currentPackageDetail) return false;
      const dateStr = this.formatDate(time);
      const saleStart = this.currentPackageDetail.sale_s_date ? this.formatDate(this.currentPackageDetail.sale_s_date) : '';
      const saleEnd = this.currentPackageDetail.sale_e_date ? this.formatDate(this.currentPackageDetail.sale_e_date) : '';
      if (saleStart && dateStr < saleStart) return true;
      if (saleEnd && dateStr > saleEnd) return true;
      return !this.hasAvailableSkuOnDate(dateStr);
    },
    hasAvailableSkuOnDate(dateStr) {
      return this.originalSkus.some((sku) => {
        const dayInfo = sku.calendar_detail && sku.calendar_detail[dateStr];
        return !!(dayInfo && (dayInfo.b2c_price || dayInfo.b2b_price));
      });
    },
    selectTimeSlot(slot) {
      this.selectedOptions.selectedTimeSlot = slot;
      this.updateSelectedSKUs();
    },
    selectSpec(specOid, specItemOid) {
      if (!this.isSpecItemAvailableForDate(specOid, specItemOid)) return;
      this.$set(this.selectedSpecs, specOid, specItemOid);
      this.matchSKUs();
      if (this.lastSpecMulti) {
        this.updateSelectedSKUs();
      }
    },
    matchSKUs() {
      const requiredSpecs = this.lastSpecMulti ? this.availableSpecs.slice(0, -1) : this.availableSpecs;
      const hasPendingRequired = requiredSpecs.some((spec) => spec.spec_items && spec.spec_items.length && !this.selectedSpecs[spec.spec_oid]);
      if (hasPendingRequired) {
        this.matchedSKUs = [];
        this.updateSelectedSKUs();
        return;
      }

      const matched = this.originalSkus
        .filter((sku) => {
          return requiredSpecs.every((spec) => {
            const selectedValue = this.selectedSpecs[spec.spec_oid];
            if (!selectedValue) return true;
            return this.getSpecValue(sku, spec.spec_oid) === selectedValue;
          });
        })
        .map((sku) => {
          const existing = this.matchedSKUs.find((item) => item.sku_id === sku.sku_id);
          return {
            ...sku,
            quantity: existing ? existing.quantity : sku.quantity || 0,
          };
        });

      this.matchedSKUs = matched;
      if (!this.lastSpecMulti && matched.length === 1 && !matched[0].quantity && this.availableSpecs.length === 0) {
        matched[0].quantity = 1;
      }
      this.updateSelectedSKUs();
    },
    getSpecValue(sku, specOid) {
      if (sku.specs_ref && Array.isArray(sku.specs_ref)) {
        const ref = sku.specs_ref.find((item) => item.spec_item_id === specOid);
        if (ref) return ref.spec_value_id;
      }
      const spec = this.availableSpecs.find((item) => item.spec_oid === specOid);
      if (!spec || !sku.spec || typeof sku.spec !== 'object') return null;
      return sku.spec[spec.spec_title] || null;
    },
    getSpecDisplayNamesFromSku(sku) {
      const names = [];
      this.availableSpecs.forEach((spec) => {
        const value = this.getSpecValue(sku, spec.spec_oid);
        const matched = spec.spec_items && spec.spec_items.find((item) => item.spec_item_oid === value);
        if (matched) names.push(matched.name);
      });
      return names.length ? names : ['默认选项'];
    },
    isSkuAvailableForDate(sku) {
      if (!this.selectedOptions.selectedDate) return !this.showDatePicker;
      const dayInfo = sku.calendar_detail && sku.calendar_detail[this.selectedOptions.selectedDate];
      if (!dayInfo) return false;
      const priceInfo = dayInfo.b2c_price || dayInfo.b2b_price;
      if (!priceInfo) return false;
      if (typeof priceInfo === 'object' && !Array.isArray(priceInfo)) {
        if (!this.selectedOptions.selectedTimeSlot) return Object.keys(priceInfo).length > 0;
        return !!priceInfo[this.selectedOptions.selectedTimeSlot];
      }
      return Number(priceInfo) > 0;
    },
    increaseSKUQuantity(sku) {
      if (!this.isSkuAvailableForDate(sku)) return;
      sku.quantity += 1;
      this.updateSelectedSKUs();
    },
    decreaseSKUQuantity(sku) {
      if (sku.quantity <= 0) return;
      sku.quantity -= 1;
      this.updateSelectedSKUs();
    },
    getLastSpec() {
      if (!this.availableSpecs.length) return null;
      return this.availableSpecs[this.availableSpecs.length - 1];
    },
    isSpecItemAvailableForDate(specOid, specItemOid) {
      if (!this.selectedOptions.selectedDate && this.showDatePicker) return false;
      const spec = this.availableSpecs.find((item) => item.spec_oid === specOid);
      const specIndex = spec ? this.availableSpecs.indexOf(spec) : -1;
      if (this.lastSpecMulti && specIndex === this.availableSpecs.length - 1) {
        for (let i = 0; i < specIndex; i += 1) {
          if (!this.selectedSpecs[this.availableSpecs[i].spec_oid]) return false;
        }
      }
      const selected = { ...this.selectedSpecs, [specOid]: specItemOid };
      return !!this.findMatchedSKU(selected);
    },
    getSpecItemQuantity(specOid, specItemOid) {
      return this.specQuantities[specOid + '_' + specItemOid] || 0;
    },
    setSpecItemQuantity(specOid, specItemOid, quantity) {
      this.$set(this.specQuantities, specOid + '_' + specItemOid, quantity);
      this.updateSelectedSKUs();
    },
    increaseSpecQuantity(specOid, specItemOid) {
      if (!this.isSpecItemAvailableForDate(specOid, specItemOid)) return;
      const current = this.getSpecItemQuantity(specOid, specItemOid);
      this.setSpecItemQuantity(specOid, specItemOid, current + 1);
    },
    decreaseSpecQuantity(specOid, specItemOid) {
      const current = this.getSpecItemQuantity(specOid, specItemOid);
      if (current <= 0) return;
      this.setSpecItemQuantity(specOid, specItemOid, current - 1);
    },
    getSpecItemPrice(specOid, specItemOid) {
      const selected = { ...this.selectedSpecs, [specOid]: specItemOid };
      const matched = this.findMatchedSKU(selected);
      if (!matched) return 0;
      return this.getSkuFinalPriceB2C(matched);
    },
    findMatchedSKU(selectedSpecs) {
      return this.originalSkus.find((sku) => {
        return Object.keys(selectedSpecs).every((specOid) => {
          if (!selectedSpecs[specOid]) return true;
          return this.getSpecValue(sku, specOid) === selectedSpecs[specOid];
        }) && this.isSkuAvailableForDate(sku);
      });
    },
    updateSelectedSKUs() {
      const selected = [];
      if (!this.lastSpecMulti) {
        this.matchedSKUs.forEach((sku) => {
          if (sku.quantity > 0) {
            selected.push({
              ...sku,
              display_name: sku.display_name || this.getSpecDisplayNamesFromSku(sku).join(' + '),
            });
          }
        });
      } else {
        const lastSpec = this.getLastSpec();
        if (lastSpec && lastSpec.spec_items) {
          lastSpec.spec_items.forEach((specItem) => {
            const quantity = this.getSpecItemQuantity(lastSpec.spec_oid, specItem.spec_item_oid);
            if (!quantity) return;
            const selectedSpecs = { ...this.selectedSpecs, [lastSpec.spec_oid]: specItem.spec_item_oid };
            const matched = this.findMatchedSKU(selectedSpecs);
            if (!matched) return;
            selected.push({
              ...matched,
              quantity,
              display_name: this.getSpecDisplayNamesFromSku(matched).join(' + '),
            });
          });
        }
      }
      this.selectedOptions.selectedSKUs = selected;
    },
    getSkuDayPrice(sku, priceType) {
      const dayInfo = this.selectedOptions.selectedDate && sku.calendar_detail
        ? sku.calendar_detail[this.selectedOptions.selectedDate]
        : null;
      const fallback = priceType === 'b2c' ? sku.b2c_price : sku.b2b_price;
      if (!dayInfo) return Number(fallback) || 0;
      const priceInfo = priceType === 'b2c' ? dayInfo.b2c_price : dayInfo.b2b_price;
      if (!priceInfo) return Number(fallback) || 0;
      if (typeof priceInfo === 'object' && !Array.isArray(priceInfo)) {
        if (this.selectedOptions.selectedTimeSlot && priceInfo[this.selectedOptions.selectedTimeSlot]) {
          return Number(priceInfo[this.selectedOptions.selectedTimeSlot]) || 0;
        }
        const firstKey = Object.keys(priceInfo)[0];
        return firstKey ? Number(priceInfo[firstKey]) || 0 : 0;
      }
      return Number(priceInfo) || 0;
    },
    getSkuFinalPrice(sku) {
      return this.getSkuDayPrice(sku, 'b2b');
    },
    getSkuFinalPriceB2C(sku) {
      return this.getSkuDayPrice(sku, 'b2c');
    },
    async confirmPackageSelection() {
      if (!this.currentPackageDetail || !this.currentItem) {
        this.$message.warning('请先选择套餐');
        return;
      }
      if (this.showDatePicker && !this.selectedOptions.selectedDate) {
        this.$message.warning('请选择出行日期');
        return;
      }
      if (this.hasTimeSlots && !this.selectedOptions.selectedTimeSlot) {
        this.$message.warning('请选择时间');
        return;
      }
      if (!this.selectedOptions.selectedSKUs.length) {
        this.$message.warning('请选择购买数量');
        return;
      }

      const requestData = {
        prod_no: parseInt(this.prodNo, 10),
        pkg_no: parseInt(this.currentPackageDetail.pkg_no || this.currentPackage.pkg_no, 10),
        item_no: parseInt(this.currentItem.item_no, 10),
        s_date: this.selectedOptions.selectedDate,
        e_date: this.selectedOptions.endDate || null,
        event_time: (this.currentItem.has_event || this.timeSlots.length > 1) ? this.selectedOptions.selectedTimeSlot : null,
        skus: this.selectedOptions.selectedSKUs.map((sku) => {
          return {
            sku_id: sku.sku_id,
            qty: sku.quantity,
            price: this.getSkuFinalPrice(sku),
            b2c_price: this.getSkuFinalPriceB2C(sku),
            specs_ref: (sku.specs_ref || []).map((item) => item.spec_value_id || item.spec_item_id).filter(Boolean),
          };
        }),
        total_price: this.totalPrice,
        b2c_total_price: this.totalPriceB2C,
        guid: this.currentPackageDetail.guid || '',
        has_rank: 'N',
        extra: {
          prod_name: this.info.prod_name,
          pkg_name: this.currentPackageDetail.pkg_name || this.currentPackage.pkg_name,
          specs: this.currentItem.specs || [],
          unit: this.currentItem.unit || '',
          unit_code: this.currentItem.unit_code || '',
          unit_max: this.currentItem.unit_max || '',
          go_date_setting: this.currentPackageDetail.go_date_setting || null,
          pkg_refund_policy: this.getPackageRefundPolicy(this.currentPackageDetail),
          refund_policy_v2: this.currentPackageDetail.refund_policy_v2 || null,
          policy_type: this.currentPackageDetail.policy_type || null,
        },
      };

      this.cache('kkday_order_req', requestData);
      this.packageDialogVisible = false;
      this.$message.success('预订信息已生成，正在进入填写页');
      this.jump('/shop/order');
    },
    getPackageRefundDesc(pkg) {
      const lines = this.getPackageRefundLines(pkg);
      return lines.length ? lines[0] : '';
    },
    getPackageRefundLines(pkg) {
      const detail = this.getPackageRefundDetail(pkg);
      const props = this.getRefundPolicyProperties(detail);
      if (props && props.partial_refund && props.partial_refund.list && props.partial_refund.list.length) {
        return props.partial_refund.list.map((item) => item.desc || '').filter(Boolean);
      }
      if (props && props.policy_type && props.policy_type.desc) {
        return [props.policy_type.desc];
      }
      if (detail && Array.isArray(detail.refund_policy_v2) && detail.refund_policy_v2.length) {
        return detail.refund_policy_v2
          .map((item) => {
            if (!item) return '';
            if (typeof item === 'string') return item;
            return item.desc || item.title || item.name || '';
          })
          .filter(Boolean);
      }
      if (detail && detail.policy_type === '1') return ['免费取消'];
      if (detail && detail.policy_type_desc) return [detail.policy_type_desc];
      return [];
    },
    getProductRefundPolicy() {
      if (!this.info) return null;
      if (this.info.description_module && this.info.description_module.PMDL_REFUND_POLICY) {
        return this.info.description_module.PMDL_REFUND_POLICY;
      }
      if (this.info.pmdl_refund_policy) return this.info.pmdl_refund_policy;
      return null;
    },
    getPackageRefundPolicy(pkg) {
      const detail = this.getPackageRefundDetail(pkg);
      if (detail && detail.description_module && detail.description_module.PMDL_REFUND_POLICY) {
        return detail.description_module.PMDL_REFUND_POLICY;
      }
      if (detail && detail.pmdl_refund_policy) return detail.pmdl_refund_policy;
      return this.getProductRefundPolicy();
    },
    getPackageRefundDetail(pkg) {
      if (!pkg) return null;
      const pkgNo = pkg.pkg_no || (pkg.detail && pkg.detail.pkg_no);
      let detail = null;
      if (pkgNo && this.packageDetails[pkgNo]) {
        detail = {
          ...(pkg || {}),
          ...this.packageDetails[pkgNo],
          detail: this.packageDetails[pkgNo],
        };
      } else {
        detail = pkg.detail || pkg;
      }

      const productRefundPolicy = this.getProductRefundPolicy();
      if (!productRefundPolicy) return detail;

      const hasPackageRefundPolicy = !!(
        detail
        && detail.description_module
        && detail.description_module.PMDL_REFUND_POLICY
      ) || !!(detail && detail.pmdl_refund_policy);

      if (hasPackageRefundPolicy) return detail;

      return {
        ...(detail || {}),
        pmdl_refund_policy: productRefundPolicy,
      };
    },
    getRefundPolicyProperties(detail) {
      if (!detail) return null;
      const moduleData = detail.description_module && detail.description_module.PMDL_REFUND_POLICY
        ? detail.description_module.PMDL_REFUND_POLICY
        : detail.pmdl_refund_policy || detail.refund_policy_v2;
      if (!moduleData) return null;
      if (moduleData.content && moduleData.content.properties) return moduleData.content.properties;
      if (moduleData.properties) return moduleData.properties;
      return moduleData;
    },
    formatSaleDate(value) {
      return value ? this.formatDate(value) : '';
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    calculateDays(startDate, endDate) {
      if (!startDate || !endDate) return 0;
      const start = new Date(startDate);
      const end = new Date(endDate);
      return Math.floor((end - start) / (24 * 60 * 60 * 1000));
    },
    getTimeSlotName(slot) {
      const map = {
        morning: '上午',
        afternoon: '下午',
        fullday: '全天',
      };
      return map[slot] || slot;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/shop/mixins/shopPurchaseMixin.js